module.exports = __webpack_public_path__ + "img/BanqueWIR_Logo_CMYK_FR.1fe30c1f.png";